import { pickGmwLibraryFields } from "../../../schema/gmw-schema-library";

import type { SourcedocumentDataSchemaFor } from "./_gmw-event-schema-collection";

export const gmwGroundLevelSchema: SourcedocumentDataSchemaFor<"GMW_GroundLevel"> = {
  type: "object",
  title: "Gebeurtenis gegevens",
  required: [
    "eventDate",
    "groundLevelStable",
    "groundLevelPosition",
    "groundLevelPositioningMethod",
  ],
  properties: pickGmwLibraryFields([
    "eventDate",
    "wellStability",
    "groundLevelStable",
    "groundLevelPosition",
    "groundLevelPositioningMethod",
  ]),
};
